export const GIC_VARIANTS = {
	DEFAULT: 'default',
	MINI: 'mini',
} as const;
